import React, {useEffect} from 'react';

import Button from '../../components/Button';
import {useAnalytics} from '../../hooks';
import {SimpleCheckIcon, SimpleLockIcon} from '../../components/svg';
import {getBrandName} from '../../components/Brand';

const features = [{
  name: 'Entire course library',
  text: 'Get full access to our course library, with hours of lessons and example answers.',
}, {
  name: 'Mock interview videos',
  text: 'Watch experts answer real interview questions in hundreds of videos.',
}, {
  name: 'Private Discord access',
  text: `Join our daily discussions with thousands of other ${getBrandName()} members on Discord.`,
}, {
  name: 'Live daily practice',
  text: 'With our new peer practice tool, you can practice with other members every day.',
}];

const ResourcePaywall = ({slug}) => {
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.resourceViewPaywall({slug});
  }, []);

  return (
    <div className="flex flex-col items-center w-full mt-6 p-8 border border-gray-200 rounded-lg bg-white">
      <SimpleLockIcon className="mt-2 mb-4 w-8 h-8 text-black" />
      <h2 className="text-center text-xl md:text-2xl font-extrabold text-black">
        Join now to continue learning
      </h2>
      <span className="text-center text-base text-gray-400 w-full md:w-2/3">
        {`As an ${getBrandName()} member, you’ll get access to this content and so much more.`}
      </span>
      <div className="flex flex-wrap flex-row justify-center">
        <Button
          className="my-4 px-10"
          href="/upgrade?src=resource"
          onClick={() => tracker.resourceClickUpgrade({slug})}
          rounded
          asLink
        >
          Upgrade now
        </Button>
      </div>
      <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-4">
        {features.map((feature) => (
          <div key={feature.name} className="relative">
            <dt>
              <SimpleCheckIcon className="absolute h-6 w-6 text-green-500" aria-hidden="true" />
              <p className="ml-9 text-lg leading-6 font-medium text-gray-800">{feature.name}</p>
            </dt>
            <dd className="mt-2 ml-9 text-base text-gray-500">{feature.text}</dd>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourcePaywall;
